import React, { useState, useEffect, useRef, useCallback } from "react";
import { DatePicker } from "antd";
import {
  FilterContainer,
  ButtonContainer,
  FilterButton,
  CustomRangePicker,
  RangePickerWrapper
} from "./styled";

const { RangePicker } = DatePicker;

const DashboardFilters = ({ onFilterChange, defaultFilter }) => {
  const [activeFilter, setActiveFilter] = useState(defaultFilter || "7D");
  const [isDatePickerVisible, setIsDatePickerVisible] = useState(false);
  const datePickerRef = useRef(null);

  useEffect(() => {
    setActiveFilter(defaultFilter);
  }, [defaultFilter]);

  useEffect(() => {
    function handleClickOutside(event) {
      if (datePickerRef.current && !datePickerRef.current.contains(event.target)) {
        setIsDatePickerVisible(false);
      }
    }

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const handleFilterClick = useCallback(
    (filter) => {
      setActiveFilter(filter);
      setIsDatePickerVisible(filter === "Custom Range");
      onFilterChange(filter, null);
    },
    [onFilterChange]
  );

  const handleDateChange = useCallback(
    (dates) => {
      if (!dates) return;
      onFilterChange("Custom Range", dates);
      setIsDatePickerVisible(false);
    },
    [onFilterChange]
  );

  return (
    <FilterContainer>
      <ButtonContainer>
        <FilterButton
          htmlType="button"
          active={activeFilter === "7D"}
          onClick={() => handleFilterClick("7D")}
          style={{ fontWeight: activeFilter === "7D" ? "700" : "400" }}
        >
          7D
        </FilterButton>
        <FilterButton
          htmlType="button"
          active={activeFilter === "14D"}
          onClick={() => handleFilterClick("14D")}
          style={{ fontWeight: activeFilter === "14D" ? "700" : "400" }}
        >
          14D
        </FilterButton>
        <FilterButton
          htmlType="button"
          active={activeFilter === "30D"}      
          onClick={() => handleFilterClick("30D")} 
        >
          30D
        </FilterButton>
      </ButtonContainer>
      {isDatePickerVisible && (
        <CustomRangePicker ref={datePickerRef}>
          <RangePickerWrapper>
            <RangePicker
              onChange={handleDateChange}
              dropdownClassName="custom-range-picker"
            />
          </RangePickerWrapper>
        </CustomRangePicker>
      )}
    </FilterContainer>
  );
};

export default React.memo(DashboardFilters);